// Dados das unidades da UNIFAP
// Este arquivo contém as localizações reais das unidades da universidade

export interface UnidadeData {
  id: number;
  latitude: number;
  longitude: number;
  accuracy: number;
  source: string;
  entity_type: string;
  entity_id: number;
  nome_unidade: string;
  sigla_unidade: string;
  id_file: string | null;
  created_at: string;
  updated_at: string;
  file: any;
}

export const unidadesData: UnidadeData[] = [
  {
    "id": 50,
    "latitude": -0.006083,
    "longitude": -51.083852,
    "accuracy": 8,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Departamento de registro e controle acadêmico",
    "sigla_unidade": "DERCA",
    "id_file": null,
    "created_at": "2025-07-01T19:25:47.999+00:00",
    "updated_at": "2025-07-01T19:25:47.999+00:00",
    "file": null
  },
  {
    "id": 49,
    "latitude": -0.005633,
    "longitude": -51.083756,
    "accuracy": 10,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Departamento de Processos Seletivos e Concursos Unifap",
    "sigla_unidade": "DEPSEC",
    "id_file": null,
    "created_at": "2025-07-01T19:23:56.021+00:00",
    "updated_at": "2025-07-01T19:23:56.021+00:00",
    "file": null
  },
  {
    "id": 48,
    "latitude": -0.005433,
    "longitude": -51.083859,
    "accuracy": 46,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco ciências ambientais",
    "sigla_unidade": "CIÊNCIAS AMBIENTAIS",
    "id_file": null,
    "created_at": "2025-07-01T19:21:52.497+00:00",
    "updated_at": "2025-07-01T19:21:52.497+00:00",
    "file": null
  },
  {
    "id": 47,
    "latitude": -0.004879,
    "longitude": -51.083834,
    "accuracy": 11,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Setor Almoxarifado Unifap",
    "sigla_unidade": "Almoxarifado",
    "id_file": null,
    "created_at": "2025-07-01T19:20:54.714+00:00",
    "updated_at": "2025-07-01T19:20:54.714+00:00",
    "file": null
  },
  {
    "id": 46,
    "latitude": -0.004645,
    "longitude": -51.08453,
    "accuracy": 17,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Setor de Patrimônio Unifap",
    "sigla_unidade": "PATRIMÔNIO",
    "id_file": null,
    "created_at": "2025-07-01T19:19:30.286+00:00",
    "updated_at": "2025-07-01T19:19:30.286+00:00",
    "file": null
  },
  {
    "id": 45,
    "latitude": -0.004559,
    "longitude": -51.083777,
    "accuracy": 6,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Setor de Transportes Unifap",
    "sigla_unidade": "Transportes",
    "id_file": null,
    "created_at": "2025-07-01T19:17:58.524+00:00",
    "updated_at": "2025-07-01T19:17:58.524+00:00",
    "file": null
  },
  {
    "id": 44,
    "latitude": -0.004275,
    "longitude": -51.083779,
    "accuracy": 6,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Departamento de Letras e artes",
    "sigla_unidade": "DEPLA",
    "id_file": null,
    "created_at": "2025-07-01T19:15:03.360+00:00",
    "updated_at": "2025-07-01T19:15:03.360+00:00",
    "file": null
  },
  {
    "id": 43,
    "latitude": -0.003111,
    "longitude": -51.084843,
    "accuracy": 6,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco engenharia civil",
    "sigla_unidade": "Engenharia civil",
    "id_file": null,
    "created_at": "2025-07-01T19:12:30.604+00:00",
    "updated_at": "2025-07-01T19:12:30.604+00:00",
    "file": null
  },
  {
    "id": 42,
    "latitude": -0.002945,
    "longitude": -51.08388,
    "accuracy": 9,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco Ciência da computação",
    "sigla_unidade": "Ciência da computação",
    "id_file": null,
    "created_at": "2025-07-01T19:10:50.788+00:00",
    "updated_at": "2025-07-01T19:10:50.788+00:00",
    "file": null
  },
  {
    "id": 41,
    "latitude": -0.002895,
    "longitude": -51.083782,
    "accuracy": 4,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco Engenharia elétrica",
    "sigla_unidade": "Engenharia elétrica",
    "id_file": null,
    "created_at": "2025-07-01T19:10:02.037+00:00",
    "updated_at": "2025-07-01T19:10:02.037+00:00",
    "file": null
  },
  {
    "id": 40,
    "latitude": -0.007006,
    "longitude": -51.084697,
    "accuracy": 20,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco dos Professores",
    "sigla_unidade": "Bloco dos Professores",
    "id_file": null,
    "created_at": "2025-06-27T19:27:11.747+00:00",
    "updated_at": "2025-06-27T19:27:11.747+00:00",
    "file": null
  },
  {
    "id": 39,
    "latitude": -0.00729,
    "longitude": -51.085111,
    "accuracy": 75,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco H",
    "sigla_unidade": "Bloco H",
    "id_file": null,
    "created_at": "2025-06-27T19:25:20.218+00:00",
    "updated_at": "2025-06-27T19:25:20.218+00:00",
    "file": null
  },
  {
    "id": 38,
    "latitude": -0.00729,
    "longitude": -51.085111,
    "accuracy": 7,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco J",
    "sigla_unidade": "Bloco J",
    "id_file": null,
    "created_at": "2025-06-27T19:24:34.682+00:00",
    "updated_at": "2025-06-27T19:24:34.682+00:00",
    "file": null
  },
  {
    "id": 37,
    "latitude": -0.007524,
    "longitude": -51.08536,
    "accuracy": 9,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco L",
    "sigla_unidade": "Bloco L",
    "id_file": null,
    "created_at": "2025-06-27T19:22:30.291+00:00",
    "updated_at": "2025-06-27T19:22:30.291+00:00",
    "file": null
  },
  {
    "id": 36,
    "latitude": -0.00783,
    "longitude": -51.084626,
    "accuracy": 6,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco C - Ciências Sociais e Sociologia",
    "sigla_unidade": "Ciências sociais e Sociologia",
    "id_file": null,
    "created_at": "2025-06-27T19:18:53.875+00:00",
    "updated_at": "2025-06-27T19:18:53.875+00:00",
    "file": null
  },
  {
    "id": 35,
    "latitude": -0.008179,
    "longitude": -51.085286,
    "accuracy": 11,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Centro Acadêmico",
    "sigla_unidade": "Centro Acadêmico",
    "id_file": null,
    "created_at": "2025-06-27T19:16:18.157+00:00",
    "updated_at": "2025-06-27T19:16:18.157+00:00",
    "file": null
  },
  {
    "id": 34,
    "latitude": -0.008179,
    "longitude": -51.085305,
    "accuracy": 14,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco E - Geografia",
    "sigla_unidade": "GEOGRAFIA",
    "id_file": null,
    "created_at": "2025-06-27T19:14:56.380+00:00",
    "updated_at": "2025-06-27T19:14:56.380+00:00",
    "file": null
  },
  {
    "id": 33,
    "latitude": -0.008108,
    "longitude": -51.084811,
    "accuracy": 4,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Departamento de Educação a Distância",
    "sigla_unidade": "DEAD",
    "id_file": null,
    "created_at": "2025-06-27T19:13:49.421+00:00",
    "updated_at": "2025-06-27T19:13:49.421+00:00",
    "file": null
  },
  {
    "id": 32,
    "latitude": -0.008177,
    "longitude": -51.084572,
    "accuracy": 9,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco B - Pedagogia",
    "sigla_unidade": "Pedagogia",
    "id_file": null,
    "created_at": "2025-06-27T19:12:44.968+00:00",
    "updated_at": "2025-06-27T19:12:44.968+00:00",
    "file": null
  },
  {
    "id": 31,
    "latitude": -0.008254,
    "longitude": -51.084498,
    "accuracy": 20,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Juizado especial virtual civil - Unifap",
    "sigla_unidade": "JUIZADO UNIFAP",
    "id_file": null,
    "created_at": "2025-06-27T19:11:24.549+00:00",
    "updated_at": "2025-06-27T19:11:24.549+00:00",
    "file": null
  },
  {
    "id": 30,
    "latitude": -0.007941,
    "longitude": -51.082842,
    "accuracy": 10,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Biblioteca Unifap",
    "sigla_unidade": "BIBLIOTECA",
    "id_file": null,
    "created_at": "2025-06-27T19:09:08.096+00:00",
    "updated_at": "2025-06-27T19:09:08.096+00:00",
    "file": null
  },
  {
    "id": 29,
    "latitude": -0.008114,
    "longitude": -51.083776,
    "accuracy": 7,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Restaurante Universitário",
    "sigla_unidade": "RU",
    "id_file": null,
    "created_at": "2025-06-27T19:07:37.134+00:00",
    "updated_at": "2025-06-27T19:07:37.134+00:00",
    "file": null
  },
  {
    "id": 28,
    "latitude": -0.008729,
    "longitude": -51.083519,
    "accuracy": 11,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco aranha",
    "sigla_unidade": "BLOCO ARANHA",
    "id_file": null,
    "created_at": "2025-06-27T19:04:23.011+00:00",
    "updated_at": "2025-06-27T19:04:23.011+00:00",
    "file": null
  },
  {
    "id": 26,
    "latitude": -0.008828,
    "longitude": -51.084522,
    "accuracy": 9,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Rádio Universitária",
    "sigla_unidade": "RÁDIO UNIVERSITÁRIA",
    "id_file": null,
    "created_at": "2025-06-27T18:59:55.107+00:00",
    "updated_at": "2025-06-27T18:59:55.107+00:00",
    "file": null
  },
  {
    "id": 25,
    "latitude": -0.008851,
    "longitude": -51.084174,
    "accuracy": 11,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco Pós Graduação",
    "sigla_unidade": "PÓS GRADUAÇÃO",
    "id_file": null,
    "created_at": "2025-06-27T18:58:34.085+00:00",
    "updated_at": "2025-06-27T18:58:34.085+00:00",
    "file": null
  },
  {
    "id": 24,
    "latitude": -0.010044,
    "longitude": -51.086408,
    "accuracy": 46,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco Curso Bacharel em Medicina",
    "sigla_unidade": "MEDICINA",
    "id_file": null,
    "created_at": "2025-06-27T18:56:18.377+00:00",
    "updated_at": "2025-06-27T18:56:18.377+00:00",
    "file": null
  },
  {
    "id": 23,
    "latitude": -0.009447,
    "longitude": -51.087505,
    "accuracy": 9,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco curso de Fisioterapia",
    "sigla_unidade": "FISIOTETAPIA",
    "id_file": null,
    "created_at": "2025-06-27T18:54:04.214+00:00",
    "updated_at": "2025-06-27T18:54:04.214+00:00",
    "file": null
  },
  {
    "id": 22,
    "latitude": -0.00922,
    "longitude": -51.087663,
    "accuracy": 9,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco Curso de Bacharel em Enfermagem",
    "sigla_unidade": "Bloco Enfermagem",
    "id_file": null,
    "created_at": "2025-06-27T18:52:19.044+00:00",
    "updated_at": "2025-06-27T18:52:19.044+00:00",
    "file": null
  },
  {
    "id": 21,
    "latitude": -0.009113,
    "longitude": -51.08768,
    "accuracy": 10,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Ambulatório Unifap",
    "sigla_unidade": "AMBULATÓRIO",
    "id_file": null,
    "created_at": "2025-06-27T18:50:48.522+00:00",
    "updated_at": "2025-06-27T18:50:48.522+00:00",
    "file": null
  },
  {
    "id": 20,
    "latitude": -0.009224,
    "longitude": -51.087849,
    "accuracy": 9,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Centro de referência integrado de atendimento em TEA",
    "sigla_unidade": "CRIATEA",
    "id_file": null,
    "created_at": "2025-06-27T18:49:21.167+00:00",
    "updated_at": "2025-06-27T19:49:21.167+00:00",
    "file": null
  },
  {
    "id": 19,
    "latitude": -0.009499,
    "longitude": -51.087781,
    "accuracy": 18,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Bloco Ciências da Saúde",
    "sigla_unidade": "Ciências da Saúde",
    "id_file": null,
    "created_at": "2025-06-27T18:47:31.918+00:00",
    "updated_at": "2025-06-27T18:47:31.918+00:00",
    "file": null
  },
  {
    "id": 18,
    "latitude": -0.00938,
    "longitude": -51.088721,
    "accuracy": 25,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Unidade básica de saúde-Unifap",
    "sigla_unidade": "UBS-UNIFAP",
    "id_file": null,
    "created_at": "2025-06-27T18:44:50.435+00:00",
    "updated_at": "2025-06-27T18:44:50.435+00:00",
    "file": null
  },
  {
    "id": 17,
    "latitude": -0.007117,
    "longitude": -51.084708,
    "accuracy": 29,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Santander Unifap",
    "sigla_unidade": "Santander",
    "id_file": null,
    "created_at": "2025-06-27T13:46:25.912+00:00",
    "updated_at": "2025-06-27T13:46:25.912+00:00",
    "file": null
  },
  {
    "id": 16,
    "latitude": -0.007462,
    "longitude": -51.084002,
    "accuracy": 13,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Centro de Vivência",
    "sigla_unidade": "CV",
    "id_file": null,
    "created_at": "2025-06-27T13:44:56.094+00:00",
    "updated_at": "2025-06-27T13:44:56.094+00:00",
    "file": null
  },
  {
    "id": 15,
    "latitude": -0.00738,
    "longitude": -51.083528,
    "accuracy": 6,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Auditório Multiuso",
    "sigla_unidade": "Anfiteatro",
    "id_file": null,
    "created_at": "2025-06-27T13:41:04.660+00:00",
    "updated_at": "2025-06-27T13:41:04.660+00:00",
    "file": null
  },
  {
    "id": 14,
    "latitude": -0.009611,
    "longitude": -51.085781,
    "accuracy": 8,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Centro de Recondicionamento de Computadores",
    "sigla_unidade": "CRC",
    "id_file": null,
    "created_at": "2025-06-26T19:46:31.781+00:00",
    "updated_at": "2025-06-26T19:46:31.781+00:00",
    "file": null
  },
  {
    "id": 13,
    "latitude": -0.009237,
    "longitude": -51.085598,
    "accuracy": 10,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Samaúma Tech",
    "sigla_unidade": "SAMAÚMA",
    "id_file": null,
    "created_at": "2025-06-26T19:44:26.739+00:00",
    "updated_at": "2025-07-30T01:25:56.851+00:00",
    "file": null
  },
  {
    "id": 12,
    "latitude": -0.009302,
    "longitude": -51.085606,
    "accuracy": 21,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Programa Unifap Digital",
    "sigla_unidade": "UNIFAP DIGITAL",
    "id_file": null,
    "created_at": "2025-06-26T19:43:31.216+00:00",
    "updated_at": "2025-06-26T19:43:31.216+00:00",
    "file": null
  },
  {
    "id": 11,
    "latitude": -0.009185,
    "longitude": -51.085196,
    "accuracy": 59,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Pró Reitoria de Ações Comunitárias",
    "sigla_unidade": "PROEAC",
    "id_file": null,
    "created_at": "2025-06-26T19:41:09.584+00:00",
    "updated_at": "2025-06-26T19:41:09.584+00:00",
    "file": null
  },
  {
    "id": 10,
    "latitude": -0.007128,
    "longitude": -51.083867,
    "accuracy": 10,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Pró Reitoria de Gestão de Pessoas",
    "sigla_unidade": "PROGEP",
    "id_file": null,
    "created_at": "2025-06-26T19:22:25.234+00:00",
    "updated_at": "2025-06-26T19:22:25.234+00:00",
    "file": null
  },
  {
    "id": 9,
    "latitude": -0.006799,
    "longitude": -51.083827,
    "accuracy": 12,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Pró Reitoria de Administração",
    "sigla_unidade": "PROAD",
    "id_file": null,
    "created_at": "2025-06-26T19:21:03.360+00:00",
    "updated_at": "2025-06-26T19:21:03.360+00:00",
    "file": null
  },
  {
    "id": 8,
    "latitude": -0.006602,
    "longitude": -51.083722,
    "accuracy": 12,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Pró Reitoria de Ensino e Graduação",
    "sigla_unidade": "PROGRAD",
    "id_file": null,
    "created_at": "2025-06-26T19:18:30.628+00:00",
    "updated_at": "2025-06-27T19:18:30.628+00:00",
    "file": null
  },
  {
    "id": 7,
    "latitude": -0.006599,
    "longitude": -51.083647,
    "accuracy": 17,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Protocolo",
    "sigla_unidade": "Protocolo",
    "id_file": null,
    "created_at": "2025-06-26T19:17:42.659+00:00",
    "updated_at": "2025-06-26T19:17:42.659+00:00",
    "file": null
  },
  {
    "id": 6,
    "latitude": -0.006619,
    "longitude": -51.08373,
    "accuracy": 100,
    "source": "gps",
    "entity_type": "servidor",
    "entity_id": 30,
    "nome_unidade": "Reitoria",
    "sigla_unidade": "REITORIA",
    "id_file": null,
    "created_at": "2025-06-26T19:16:47.896+00:00",
    "updated_at": "2025-06-26T19:16:47.896+00:00",
    "file": null
  }
];

// Coordenadas padrão do centro do mapa (UNIFAP)
export const defaultMapCenter: [number, number] = [-0.006083, -51.083852];

// Zoom padrão do mapa
export const defaultMapZoom = 15;
